export enum PaypalRequestIntent {
  SALE = 'sale',
  AUTHORIZE = 'authorize',
  ORDER = 'order'
}
